import React from 'react';

const NewArrivals = () => {
  return (
    <div>NewArrivals</div>
  )
}

export default NewArrivals